import { createContext, useContext, useState, ReactNode } from 'react'
import dayjs from 'dayjs'

type GeneralContextType = {
    from: number
    to: number
    setFromGeneral: (value: number) => void
    setToGeneral: (value: number) => void
}

const GeneralContext = createContext<GeneralContextType | null>(null)

export const GeneralProvider = ({ children }: { children: ReactNode }) => {
    const [from, setFromGeneral] = useState(
        dayjs().add(-92, 'days').startOf('day').unix()
    )
    const [to, setToGeneral] = useState(dayjs().endOf('day').unix())

    return (
        <GeneralContext.Provider
            value={{ from, to, setFromGeneral, setToGeneral }}
        >
            {children}
        </GeneralContext.Provider>
    )
}

export const useGeneral = () => {
    const ctx = useContext(GeneralContext)
    if (!ctx) {
        throw new Error('useGeneral must be used inside GeneralContext')
    }
    return ctx
}
